module.exports = __webpack_public_path__ + "static/media/aerocloud.2a891d6c.svg";